import React from "react";
import { Helmet } from "react-helmet";
import DefaultLayout from "../../layouts/DefaultLayout";
import Hero from "../../components/Hero";
import ElsNostresEspais from "../../components/ElsNostresEspais";

const Home: React.FC = () => {
  return (
    <DefaultLayout
      title="ACD Invest — Immobiliari i inversió a Andorra"
      description="ACD Invest: agència immobiliària i inversió a Andorra. Espais residencials i comercials únics en un entorn natural privilegiat. Descobreix el teu futur espai."
    >
      <Helmet>
        <title>ACD Invest — Immobiliari i inversió a Andorra</title>
        <meta
          name="description"
          content="ACD Invest: agència immobiliària i inversió a Andorra. Espais residencials i comercials únics en un entorn natural privilegiat. Descobreix el teu futur espai."
        />
        <meta name="robots" content="index, follow" />
        <link rel="canonical" href="https://acdinvest.ad/" />
      </Helmet>
      <Hero />
      <div id="els-nostres-espais">
        <ElsNostresEspais />
      </div>
    </DefaultLayout>
  );
};

export default Home;
